import React from 'react'

import {
    isRegionId,
    normalizeRegionId,
    parseRegionId,
} from '@gnomad/identifiers'
import RegionPage from './RegionPage'
import BaseQuery from '../../BaseQuery'
import { BaseQueryChildrenType } from '../../types/BaseQueryChildrenType'
import { gql } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { REGION_LENGTH_QUERY } from '@/graphql/query/regionCount'
import Alert from '@mui/material/Alert'
import {getDatasetId} from '@/utils/paramUtils'

const query = gql`
    query Region($chrom: String!, $start: Int!, $stop: Int!, $datasetId: String!) {
        region(chrom: $chrom, start: $start, stop: $stop, dataset_id: $datasetId) {
            chrom
            start
            stop
            gene_ids
            gene_symbols
            variants {
                chrom
                ref
                alt
                length
                transcript_id_canonical
                source
                czechgenome_genome_frequencies {
                    population_subtype
                    variant_id
                    allele_stats {
                        allele_count
                        allele_number
                        homozygote_count
                        allele_frequency
                    }
                }
                transcript_consequence_major {
                    gene_symbol
                    gene_id
                    consequence
                    transcript_id
                }
                source
                pos
                variant_id
                clinical_significance
                rsids
            }
        }
    }
`

type Params = {
    regionId: string
}

export default function RegionPageContainer() {
    const { regionId = '' } = useParams<Params>()
    const datasetId = getDatasetId()

    const normalizedRegionId = normalizeRegionId(regionId)

    if (!isRegionId(regionId)) {
        return <></>
    }

    const { chrom, start, stop } = parseRegionId(normalizedRegionId)

    const variables = {
        chrom,
        start,
        stop,
        datasetId
    }

    return (
        <BaseQuery
            query={REGION_LENGTH_QUERY}
            variables={variables}
            loadingMessage='Loading region'
        >
            {({ data }: BaseQueryChildrenType) => {
                if (data.regionCount > 10000) {
                    return (
                        <Alert severity='error'>
                            Entered range is too big!
                        </Alert>
                    )
                } else {
                    return (
                        <BaseQuery
                            query={query}
                            variables={variables}
                            loadingMessage='Loading region'
                        >
                            {({ data }: BaseQueryChildrenType) => {
                                return (
                                    <RegionPage
                                        region={{
                                            ...data.region,
                                            chrom,
                                            start,
                                            stop,
                                        }}
                                    />
                                )
                            }}
                        </BaseQuery>
                    )
                }
            }}
        </BaseQuery>
    )
}
